import React from "react";
import "./Landing.css";
import { Link } from "react-router-dom";

const Landing = () => {
	return (
		<div className='uiowa-landing'>
			<div className='overlay'>
				<div className='inner'>
					<h1>Start your story here</h1>

					<div className='btn-wrapper d-flex gap-4 align-items-center'>
						<Link className='btnUiowa d-flex align-items-center  gap-3'>
							VIRTUAL TOUR
							<i
								className='fa fa-arrow-right'
								style={{ color: "#fff" }}
								aria-hidden='true'
							></i>
						</Link>
						<Link className='btnUiowa d-flex align-items-center  gap-3'>
							AREAS OF STUDY
							<i
								className='fa fa-arrow-right'
								style={{ color: "#fff" }}
								aria-hidden='true'
							></i>
						</Link>
						<Link className='btnUiowa d-flex align-items-center  gap-3'>
							COST AND AID
							<i
								className='fa fa-arrow-right'
								style={{ color: "#fff" }}
								aria-hidden='true'
							></i>
						</Link>
					</div>
				</div>
			</div>
		</div>
	);
};

export default Landing;
